import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import styles from "./Modal.module.css";
/** Seletores de elementos focáveis (ordem padrão de tabulação) */
const FOCUSABLE_SELECTORS = [
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "[tabindex]:not([tabindex='-1'])",
    "details > summary",
].join(", ");
function getFocusableElements(container) {
    return Array.from(container.querySelectorAll(FOCUSABLE_SELECTORS));
}
/**
 * Modal do Azim CRM.
 * Gerencia foco: ao abrir, move o foco para o painel.
 * Implementa focus trap: Tab/Shift+Tab cicla dentro do painel.
 * Fecha com Esc ou clique no overlay.
 * Superfície plana sem gradientes.
 */
export function Modal({ open, onClose, children, width = 520, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, }) {
    const panelRef = useRef(null);
    useEffect(() => {
        if (!open)
            return;
        const previousFocus = document.activeElement;
        panelRef.current?.focus();
        const handleKey = (e) => {
            if (e.key === "Escape") {
                onClose();
                return;
            }
        };
        window.addEventListener("keydown", handleKey);
        return () => {
            window.removeEventListener("keydown", handleKey);
            previousFocus?.focus();
        };
    }, [open, onClose]);
    if (!open)
        return null;
    const handleOverlayMouseDown = (e) => {
        if (e.target === e.currentTarget)
            onClose();
    };
    const handlePanelKeyDown = (e) => {
        if (e.key !== "Tab")
            return;
        const panel = panelRef.current;
        if (!panel)
            return;
        const focusable = getFocusableElements(panel);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (!first || !last) {
            e.preventDefault();
            return;
        }
        if (e.shiftKey) {
            // Shift+Tab: se o foco está no primeiro (ou no próprio painel), cicla para o último
            if (document.activeElement === first || document.activeElement === panel) {
                e.preventDefault();
                last.focus();
            }
        }
        else {
            // Tab: se o foco está no último (ou no próprio painel sem filhos), cicla para o primeiro
            if (document.activeElement === last || document.activeElement === panel) {
                e.preventDefault();
                first.focus();
            }
        }
    };
    return (_jsx("div", { className: styles.overlay, role: "presentation", onMouseDown: handleOverlayMouseDown, children: _jsx("div", { ref: panelRef, className: styles.panel, style: { maxWidth: width }, role: "dialog", "aria-modal": "true", "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, tabIndex: -1, onKeyDown: handlePanelKeyDown, children: children }) }));
}
//# sourceMappingURL=Modal.js.map